import { type FormControlLabelProps, Switch, type SwitchProps, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { SwitchFormControlLabel, classes } from "./styles";

interface ILabeledSwitch {
  label: ReactNode;
  value: boolean;
  onChange: Exclude<SwitchProps["onChange"], undefined>;
  SwitchProps?: Omit<SwitchProps, "checked" | "onChange">;
  FormControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
}

export const LabeledSwitch = ({ label, value, onChange, SwitchProps, FormControlLabelProps }: ILabeledSwitch) => {
  return (
    <SwitchFormControlLabel
      className={classes.root}
      control={<Switch checked={value} size="small" onChange={onChange} color="primary" {...SwitchProps} />}
      label={typeof label === "string" ? <Typography variant="body1SemiBold">{label}</Typography> : label}
      labelPlacement="start"
      {...FormControlLabelProps}
    />
  );
};
